module.exports = __webpack_public_path__ + "img/remax-petovio.png";